import React, { useState } from 'react';
import "../css/pages.css"
import { useLocation } from 'react-router-dom';
import CardPaymentModal from '../Components/CardPaymentModal'; // Assuming you have a CardPaymentModal component

const Payment = () => {
  const location = useLocation();
  // const navigate = useNavigate();
  const { location:   userLocation, estate, paymentType, accountType, meterNumber, phoneNumber, amount, price, numberOfUnits, waterAmount } = location.state || {};

  const [showModal, setShowModal] = useState(false);

  const handlePaymentOption = (option) => {
    console.log(`Payment option selected: ${option}`);
    if (option === 'card') {
      setShowModal(true);
    } else {
      // Implement transfer payment processing logic here
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className='payment section__padding'>
        <div className='pay_Sec'>
        <div className='payment_contain section__margin'>
      <div className="content">
        <div className='payname'><h2>Payment Page</h2></div>
        <div className="payment-summary">
          <p><strong>Location:</strong> {userLocation}</p>
          <p><strong>Payment Type:</strong> {paymentType}</p>
          {/* Conditionally render Estate based on payment type */}
          {paymentType === 'Water' && <p><strong>Estate:</strong> {estate}</p>}
          {price && <p><strong>Price:</strong> ₦{price}</p>}
          {amount && <p><strong>Amount:</strong> ₦{amount}</p>}
          <p><strong>Account Type:</strong> {accountType}</p>
          <p><strong>Meter Number:</strong> {meterNumber}</p>
          <p><strong>Phone Number:</strong> {phoneNumber}</p>
           {/* Conditionally render Number of Units based on payment type */}
            {paymentType === 'Electricity' && <p><strong>Number of Units: </strong>{numberOfUnits}</p>}
          {paymentType === 'Water' && <p><strong>Water Amount (Cubic Meters): </strong>{waterAmount}</p>}
        </div>
        <div className="button-container">
          <button onClick={() => handlePaymentOption('transfer')} className='cardbtn'>Pay with Transfer</button>
          <button onClick={() => handlePaymentOption('card')} className='cardbtn'>Pay with Card</button>
        </div>
      </div>
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <CardPaymentModal
              userLocation={userLocation}
              estate={estate}
              paymentType={paymentType}
              accountType={accountType}
              meterNumber={meterNumber}
              phoneNumber={phoneNumber}
              amount={amount}
              price={price}
            />
          </div>
        </div>
      )}
    </div>
        </div>
        
    </div>
    
  );
};

export default Payment;
